import classNames from 'classnames';
import React__default from 'react';
import isEqual from 'react-fast-compare';
import Alert from 'react-s-alert';
import styles from './NotificationTemplate.module.scss.js';

var NotificationTemplate = React__default.memo(function (props) {
    var _a, _b;
    var close = function () {
        Alert.close(props.id);
    };
    var isError = !!props.customFields.isError;
    var wrapper = classNames(styles.wrapper, props.className, (_a = {},
        _a[props.classNames] = !!props.classNames,
        _a));
    var bodyClassname = classNames(styles.body, (_b = {},
        _b[styles.errorBody] = isError,
        _b[styles.taggedBody] = !props.customFields.header && !isError,
        _b));
    return (React__default.createElement("div", { className: wrapper, id: "" + props.id, style: props.styles, onClick: close },
        props.customFields.header && (React__default.createElement("div", { className: styles.header, dangerouslySetInnerHTML: { __html: props.customFields.header } })),
        React__default.createElement("div", { className: bodyClassname },
            React__default.createElement("div", { className: styles.bodyContent, dangerouslySetInnerHTML: { __html: props.customFields.message } }))));
}, isEqual);

export { NotificationTemplate as default };
//# sourceMappingURL=NotificationTemplate.js.map
